import { el, numFormat } from '../../lib/dom.js';
import type { KatalogResponse } from '../../lib/api.js';

type Kategorie = 'neben' | 'kulturen' | 'zier';
const TITEL: Record<Kategorie, string> = {
  neben: 'Nebenanlage wählen',
  kulturen: 'Kultur wählen',
  zier: 'Zierbegrünung wählen',
};

/** Durchsuchbarer Katalog-Picker als Bottom-Sheet. */
export function openPicker(
  katalog: KatalogResponse,
  kategorie: Kategorie,
  onSelect: (eintrag: { n: string; e: string; p: number; g: string | null }) => void,
): void {
  const modal = el('div', { class: 'modal open', role: 'dialog', 'aria-modal': 'true' });
  const sheet = el('div', { class: 'sheet' });
  const header = el('header');
  header.append(el('h3', {}, TITEL[kategorie]));
  const search = el('input', {
    type: 'text',
    placeholder: 'Suchen … (z. B. Zaun)',
    autocomplete: 'off',
  });
  header.append(search);
  const list = el('div', { class: 'list' });
  const footer = el('footer');
  const close = el('button', { class: 'btn', type: 'button' }, 'Abbrechen');
  footer.append(close);
  sheet.append(header, list, footer);
  modal.append(sheet);

  const dispose = () => modal.remove();
  close.addEventListener('click', dispose);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) dispose();
  });
  modal.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') dispose();
  });

  const renderList = (q: string) => {
    list.replaceChildren();
    const treffer = katalog.katalog[kategorie].filter((k) =>
      k.n.toLowerCase().includes(q.toLowerCase()),
    );
    if (treffer.length === 0) {
      list.append(el('div', { class: 'list-empty' }, 'Nichts gefunden.'));
      return;
    }
    for (const k of treffer) {
      const b = el('button', { class: 'pickitem', type: 'button' });
      b.append(
        el('span', {}, k.n),
        el('span', { class: 'price' }, k.p ? `${numFormat(k.p)} € / ${k.e}` : 'frei'),
      );
      b.addEventListener('click', () => {
        dispose();
        onSelect(k);
      });
      list.append(b);
    }
  };
  search.addEventListener('input', () => renderList(search.value));
  renderList('');
  document.body.append(modal);
  search.focus();
}
